function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M6 7H12V13H6V7ZM13 15H6V17H18V15H14H13ZM14 11H18V13H14V11ZM14 7H18V9H14V7Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.125 3H15V5H4.125C4.04 5 3.995 5.036 3.988 5.046L4 18.992C4.001 18.986 4.005 18.984 4.012 18.984C4.018 18.984 4.02675 18.986 4.03807 18.9886C4.0588 18.9933 4.08813 19 4.125 19H19.875C19.96 19 20.005 18.964 20.012 18.954L20.0043 10H22V19C22 20.103 21.047 21 19.875 21H4.125C2.953 21 2 20.103 2 19V5C2 3.897 2.953 3 4.125 3ZM22 6V5C22 3.897 21.047 3 19.875 3H17V5H19.875C19.9118 5.00047 19.9407 5.00656 19.9615 5.01093C19.9854 5.01595 19.9984 5.01869 20 5.008L20.0009 6H22Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 0H20V3H17V5H20V8H22V5H25V3H22V0Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  d: "M0 0H24V24H0V0Z",
  fill: "white"
})));

var SvgAddNews = function SvgAddNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddNews.7960bfc4.svg";
export { ForwardRef as ReactComponent };